import React from "react";
import HighlightText from "./HighlightText";
import CTAButton from "./Button";
import { FaArrowRight } from "react-icons/fa";
import { TypeAnimation } from "react-type-animation";

function CodeBlocks({
  position,
  heading,
  subheading,
  ctabtn1,
  ctabtn2,
  codeblock,
  backgroundGradient,
  codeColor,
}) {
  return (
    <div className={`flex ${position} my-20 justify-between gap-10`}>
      {/* section 1 */}
      <div className="md:w-[50%] flex flex-col gap-8">
        {heading}
        <div className="text-richblack-300 font-bold text-md">{subheading}</div>
        <div className="flex flex-row gap-6 mt-7">
          <CTAButton active={ctabtn1.active} linkto={ctabtn1.linkto}>
            <div className="flex gap-2 items-center">
              {ctabtn1.btnText}
              <FaArrowRight />
            </div>
          </CTAButton>
          <CTAButton active={ctabtn2.active} linkto={ctabtn2.linkto}>
            {ctabtn2.btnText}
          </CTAButton>
        </div>
      </div>

      
      {/* section 2 */}
      <div className="h-fit code-border flex flex-row text-[15px] w-[100%] max-[450px]:w-[80%] py-4 lg:w-[500px] bg-gradient-to-r from-[#0e1a2d38] via-[#111e3254] to-transparent bg-opacity-10">
        {/* Gradient */}
        {backgroundGradient}
        <div className="text-center flex flex-col w-[10%] text-richblack-400 font-inter font-bold">
            <p>1</p>
            <p>2</p>
            <p>3</p>
            <p>4</p>
            <p>5</p>
            <p>6</p>
            <p>7</p>
            <p>8</p>
            <p>9</p>
            <p>10</p>
            <p>11</p>
        </div>
        <div className={`w-[90%] flex flex-col gap-2 font-bold font-mono ${codeColor} pr-2`}>
            <TypeAnimation
                sequence={[codeblock,5000,""]}
                repeat={Infinity}
               style={
                {
                    whiteSpace: "pre-line",
                    display: "block",
                }
               }
               omitDeletionAnimation={true}
            />
        </div>
        
      </div>

    </div>
  );
}

export default CodeBlocks;
